import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Clock } from 'lucide-react';

export default function SessionWarning() {
  const { sessionWarning, resetTimer } = useAuth();
  if (!sessionWarning) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[10000] flex items-center justify-center gap-3 bg-yellow-500 text-black text-sm font-bold px-4 py-3" data-testid="session-warning-banner">
      <Clock size={16} />
      <span>Your session will expire in 2 minutes due to inactivity.</span>
      <button
        onClick={resetTimer}
        className="ml-2 px-4 py-1 bg-black text-white text-xs font-bold uppercase tracking-wider rounded hover:bg-gray-800 transition-colors"
        data-testid="session-stay-btn"
      >
        Stay Logged In
      </button>
    </div>
  );
}
